const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '所有漫画免费阅读，无需付费订阅，让每个人都能享受漫画的乐趣。',
    bg: 'bg-primary-50 text-primary-500',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '每日同步更新最新话，与韩国发布进度保持一致，绝不让您久等。',
    bg: 'bg-accent-50 text-accent-600',
  },
  {
    icon: 'ri-translate',
    title: '高品质翻译',
    desc: '专业翻译团队精心打磨，确保每一句台词的原汁原味和阅读流畅度。',
    bg: 'bg-secondary-50 text-secondary-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配手机、平板和电脑，随时随地享受流畅的漫画阅读体验。',
    bg: 'bg-primary-50 text-primary-500',
  },
  {
    icon: 'ri-bookmark-line',
    title: '海量资源',
    desc: '5000+部韩漫作品，覆盖恋爱、奇幻、动作等8大分类，总有你喜欢的。',
    bg: 'bg-accent-50 text-accent-600',
  },
  {
    icon: 'ri-user-heart-line',
    title: '社区互动',
    desc: '与其他读者一起讨论剧情，分享阅读感受，找到志同道合的漫画伙伴。',
    bg: 'bg-secondary-50 text-secondary-600',
  },
];

export default function PlatformAdvantage() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台<strong className="text-primary-500">优势</strong>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么200万+读者选择韩漫屋？
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          <div className="lg:col-span-1 lg:row-span-2 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20readers%20enjoying%20Korean%20manhwa%20on%20various%20devices%2C%20diverse%20group%2C%20warm%20atmosphere%2C%20modern%20lifestyle%2C%20clean%20cream%20background%2C%20editorial%20photography%20style&width=600&height=800&seq=about-advantage-main&orientation=portrait"
              alt="韩漫屋平台优势"
              title="韩漫屋 - 最好的韩漫阅读体验"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>

          {advantages.map((adv) => (
            <div
              key={adv.title}
              className="bg-background-50 rounded-lg p-5 md:p-6 hover:bg-background-200/50 transition-colors"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full ${adv.bg} mb-4`}>
                <i className={`${adv.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-950 mb-2">
                {adv.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {adv.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}